import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Select, Card, Row, Col, DatePicker } from 'antd';
import { HrmsEmployeeDetailsDto, HrmsEmployeeRequest } from '@gtpl/shared-models/masters';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { HrmsEmpDetService } from '@gtpl/shared-services/masters';
import { Link, useHistory } from "react-router-dom";
import { ApplyForLeavesDto, GetAllAvailableLeavesDto, GetEmpAvlLeaves, TypesOfLeavesDto } from '@gtpl/shared-models/hrms';
import { ApplyForLeavesService, EmployeeLeavesService, TypesOfLeavesService } from '@gtpl/shared-services/hrms';
import moment from 'moment';

import './apply-for-leaves-form.css';

const { Option } = Select;
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 8,
  },
};


const tailLayout = {
  wrapperCol: {
    offset: 10,
    span: 10,
  },
};

/* eslint-disable-next-line */
export interface ApplyForLeavesFormProps {
  applyForLeavesData: ApplyForLeavesDto;
  updateDetails: (hrms: ApplyForLeavesDto) => void;
  isUpdate: boolean;
  closeForm: () => void;
}

export function ApplyForLeavesForm(
  props: ApplyForLeavesFormProps
) {

  const [form] = Form.useForm();
  const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
  const [typesOfLeaveData, setTypesOfLeavesData] = useState<TypesOfLeavesDto[]>([]);
  const [selectedTypesOfLeaves, setSelectedTypesOfLeaves] = useState<TypesOfLeavesDto[]>([]);
  const [fromDate, setFromDate] = useState<moment.Moment>(moment());
  const [availableLeaves, setAvailableLeaves] = useState<number>(0);
  const [totalLeaves, setTotalLeaves] = useState<number>(0);



  const { TextArea } = Input;

  const service = new HrmsEmpDetService();
  const typesOfLeavesService = new TypesOfLeavesService();
  const applyforLeavesService = new ApplyForLeavesService();  
  const employeeLeavesService = new EmployeeLeavesService();

  let history = useHistory();

  let createdUser = "";
  if (!props.isUpdate) {
    createdUser = localStorage.getItem("createdUser");
  }

  useEffect(() => {
    getAllActiveEmployeesForLeaves();
    getAllTypesOfLeaves();
  }, [])

  const getAllActiveEmployeesForLeaves = () => {
    service.getAllActiveEmployeesForLeaves().then(res => {
      if (res.status) {
        setEmployeeData(res.data);
      } else {
        if (res.intlCode) {
          setEmployeeData(res.data);
          console.log(res.data)
          // AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          //  AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setEmployeeData([]);
      // AlertMessages.getErrorMessage(err.message);
    })
  }

  const getEmployeeDetails = () => {
    const employeeId = form.getFieldValue('employeeId')
    const request = new HrmsEmployeeRequest(employeeId);
    service.getActiveEmployeesById(request).then(res => {
      if (res.status) {
        console.log(res.data.employeeName);
        form.setFieldsValue({
          employeeName: res.data.employeeName,


        });
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getAllTypesOfLeaves = () => {
    typesOfLeavesService.getAllActiveTypesOfLeaves().then(res => {
      if (res.status) {
        setTypesOfLeavesData(res.data);
      } else {
        if (res.intlCode) {
          setTypesOfLeavesData([]);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setTypesOfLeavesData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const getAllAvailableLeaves = (selected: number) => {
    const employeeId = form.getFieldValue('employeeId')
    const req = new GetEmpAvlLeaves(`${new Date().getFullYear()}`,employeeId, selected)
    employeeLeavesService.getAllAvailableLeaves(req).then(res => {
      if (res.status) {
        setAvailableLeaves(res.data);
      } else {
        if (res.intlCode) {
          setAvailableLeaves(0);
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setAvailableLeaves(0);
      AlertMessages.getErrorMessage(err.message);
    })
  }


  const createLeave = (Data: ApplyForLeavesDto) => {
    applyforLeavesService.createLeave(Data).then(res => {
      if (res.status) {
        AlertMessages.getSuccessMessage('Leave Applied successfully');
        history.push('/apply-for-leaves-grid');
        onReset();
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const saveData = (values: ApplyForLeavesDto) => {
    if (props.isUpdate) {
      console.log(values);
      props.updateDetails(values);
    } else {
      console.log(values);
      createLeave(values);
    }
  };

  const onReset = () => {
    form.resetFields();
  }
  const onFocus = () => {
    console.log('focus');
  }

  const onSearch = (val) => {
    console.log('search:', val);
  }
  const onBlur = () => {
    console.log('blur');
  }


  const getNoOfDays = (dateType: string) => {
    const fromDate = form.getFieldValue('fromDate');
    const toDate = form.getFieldValue('toDate');
    if (moment(fromDate).format('dddd') === 'Sunday' || moment(toDate).format('dddd') === 'Sunday') {
      AlertMessages.getErrorMessage('Selected day should not be a sunday');
      if (dateType == 'fromDate') {
        setFromDate(moment());
        form.setFieldsValue({
          fromDate: moment()
        })
      }
      if (dateType == 'toDate') {
        form.setFieldsValue({
          toDate: moment()
        })
      }
      let noOfDays=0;
      if (form.getFieldValue('leaveToDay') == 'Half Day'){
        noOfDays=0.5;
      }else{
        noOfDays=1;
      }
      form.setFieldsValue({
        noOfDays: noOfDays
      })
      return false;
    } else {
      if (dateType == 'fromDate') {
        setFromDate(moment(fromDate));
        form.setFieldsValue({
          toDate: moment(fromDate)
        })
      }
    }
    const d1 = moment(form.getFieldValue('fromDate'), 'YYYY-MM-DD');
    const d2 = moment(form.getFieldValue('toDate'), 'YYYY-MM-DD');
    // Calc all days used including last day ( the +1 )
    const days = d2.diff(d1, 'days') + 1;

    console.log('Days:', days);

    // how many full weekends occured in this time span
    const weekends = Math.floor(days / 7);

    console.log('Full Weekends:', weekends);

    // Subtract all the weekend days
    let businessDays = days - (weekends * 1);

    // Special case for weeks less than 7
    if (weekends === 0) {
      const cur = d1.clone();
      for (let i = 0; i < days; i++) {
        if (cur.day() === 0) {
          businessDays--;
        }
        cur.add(1, 'days')
      }
    } else {
      // If the first day is a sunday we need to account for it
      if (d1.day() === 0) {
        console.log('Extra weekend day (Sunday)');
        businessDays--;
      }
    }

    console.log('Business days:', businessDays);
    console.log(form.getFieldValue('leaveToDay'));
    setTotalLeaves(businessDays);
    
    if (form.getFieldValue('leaveToDay') == 'Full Day') {
      form.setFieldsValue({
        noOfDays: businessDays
      })
    }
    else if (form.getFieldValue('leaveToDay') == 'Half Day') {
      if(businessDays>1){
        AlertMessages.getErrorMessage('Selected period should not exceed more than 1 day for half day leaves');
        setTotalLeaves(0);
        form.setFieldsValue({
          toDate: d1
        })
        return false;
      }
      const leaves=businessDays-0.5;
      form.setFieldsValue({
        noOfDays: leaves
      })
    }
    else {
      form.setFieldsValue({
        noOfDays: businessDays
      })
    };

  }

  function disabledDate(current) {
    // Can not select days before today and today
    return current && current < fromDate;
  }



  return (
    <Card title={<span style={{ color: 'white' }}>Apply for leaves</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate == true ? "" : <Link to='/apply-for-leaves-grid' ><span style={{ color: 'white' }} ><Button className='panel_button' >View </Button> </span></Link>} >


      <Form form={form}
        name="control-hooks"
        layout="vertical"
        onFinish={saveData}
      >

        <Form.Item name="transferActionId" style={{ display: "none" }} >
          <Input hidden />
        </Form.Item>

        <Form.Item style={{ display: "none" }} name="createdUser" initialValue={createdUser}>
          <Input hidden />
        </Form.Item>
        <Row>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="employeeId"
              label="Employee Code"
              rules={[
                {
                  required: true,
                  message: "code is required"
                },

              ]}
            >

              <Select
                showSearch
                //style={{ width: 210 }}
                placeholder="Select Employee Code"
                optionFilterProp="children"
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                onChange={getEmployeeDetails}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                <Option key={0} value={null}>Select Employee code</Option>
                {employeeData.map((employeeData) => {
                  return <Option key={employeeData.employeeId} value={employeeData.employeeId}>{employeeData.employeeCode}</Option>
                })}
              </Select>

            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="employeeName"
              label="Employee Name"
              rules={[
                {
                  required: true,
                  message: "name is required"
                },
              ]}>
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="typeOfLeave"
              label={<span>Type of Leave ||  Available Leaves : {availableLeaves}</span>}
              rules={[
                {
                  required: true,
                  message: "Leave is required"
                },

              ]} >
              <Select
                showSearch
                placeholder="Select Type of Leave"
                optionFilterProp="children"
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                onChange={getAllAvailableLeaves}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }>
                <Option key={0} value={null}>Select Type of Leave</Option>
                {typesOfLeaveData.map((typesOfLeaveData) => {
                  return <Option key={typesOfLeaveData.typeOfLeaveId} value={typesOfLeaveData.typeOfLeaveId}>{typesOfLeaveData.typeOfLeave}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item name="fromDate" label="From Date" initialValue={moment()}>
              <DatePicker
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
                onChange={(selected) => {setFromDate(selected);getNoOfDays('fromDate')}}
                showToday={true} />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item name="toDate" label="To Date" initialValue={moment()}>
              <DatePicker
                style={{ width: '100%' }}
                format="YYYY-MM-DD"
                onChange={() => getNoOfDays('toDate')}
                showToday={true}
                disabledDate={disabledDate}
              />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item
              name="leaveToDay"
              label="Leave to Day"
              rules={[
                {
                  required: true,
                  message: "to day is required"
                }
              ]}
            > <Select
                showSearch
                placeholder="Leave to day"
                optionFilterProp="children"
                onFocus={onFocus}
                onBlur={onBlur}
                onSearch={onSearch}
                onChange={(selected)=>{
                  form.setFieldsValue({leaveToDay:selected});
                  getNoOfDays('')
                }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                <Option key={0} value={null}>select to Day</Option>
                <Option key={1} value={'Half Day'} disabled={totalLeaves > 1}>Half Day</Option>
                <Option key={2} value={'Full Day'}>Full Day</Option>

              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item name="noOfDays"
              label="No of Leave days"
              rules={[
                {
                  required: true
                },

              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item name="leaveReason"
              label="Leave Reason"
              rules={[
                {
                  required: true,
                  message: " Reason is required"
                },
                {
                  pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                  message: `Should contain only alphabets.`
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }}>
            <Form.Item name="leaveAddress"
              label="Leave Address"
              rules={[
                {

                  required: true,
                  message: " Address is required",
                  pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                },

              ]}>

              <TextArea rows={2} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
            {/* {(props.isUpdate === true) && */}

            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
              Reset
            </Button>
            {/* } */}
          </Col>
        </Row>
      </Form>
    </Card>
  );
}

export default ApplyForLeavesForm;
